import { generateUrl, paths } from 'shared/base';

export const getReportUrl = (id: string, team: string, editorOpen = false) => {
  return generateUrl({
    pathname: paths.platform.team.reports.report,
    query: { id, team, ...(Boolean(editorOpen) && { editorOpen }) },
  });
};
